import { useLinesVodGenresStore } from "@/stores/LinesVodGenres";
import { useMultiLinesVodGenresStore } from "@/stores/MultiLinesVodGenres";
import { type RouteLocationNormalized } from 'vue-router';
import { linkItems } from "@/components/Header/types";

const {
	fetchNewShowsGenres,
	fetchMoviesGenres,
	setCurrentGenre,
	fetchSubGenres,
	clearAllLinesVodGenresStore,
} = useLinesVodGenresStore();
const {
	fetchShowsGenres,
	clearMultiLinesVodGenres
} = useMultiLinesVodGenresStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized,  from: RouteLocationNormalized) => {
	if (import.meta.client) {
		try {
			if (to.params.id){
				// If we are on the same page or move from 'onDemand', we clear store
				if (to.name === from.name || from.path === linkItems.onDemand.routerPath) {
					clearAllLinesVodGenresStore();
					clearMultiLinesVodGenres();
				}

				const genre = setCurrentGenre(Number(to.params.id));
				if (!genre) {
					throw new Error('middleware "fetchVodGenres" genre is null');
				}

				fetchSubGenres();

				void fetchNewShowsGenres();

				void fetchMoviesGenres();

				void fetchShowsGenres();
			} else {
			  throw new Error('middleware "fetchVodGenres" abortNavigation');
			}
		  } catch (error) {
			console.error(error);
			abortNavigation();
		  }
	}
});